import exceljs from "exceljs";
import { saveAs } from "file-saver";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import {
    round, getDatefromWeekNum, 
    weekDays, numberReducer,
    mimeTypeMap, MyDate
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Export({
    forms, wk
}){
    const user = useMyStore(state => state.user);
    const exportFunc = () => {
        const getReg = val => val > 8?8: val;
        const getOT = val => val > 8?val - 8: 0;

        if(!forms.length){
            window.alert("No data to export.");
            return;
        }
        const mainData = forms
        .map(c => c.find(cc => cc.week === wk))
        .filter(c => c.status === "Approved")
        .map(c => ({
            ...c, 
            name: c.userName, 
            totalReg: c.form.map(cc => 
                getReg(cc.inOut.length && cc.inOut.map(a => a.duration || 0).map(value => round(value, 2)).reduce(numberReducer, 0))
            ).reduce(numberReducer, 0),
            totalOT: c.form.map(cc => 
                getOT(cc.inOut.length && cc.inOut.map(a => a.duration || 0).map(value => round(value, 2)).reduce(numberReducer, 0))
            ).reduce(numberReducer, 0),
    }));
        if(!mainData.length){
            window.alert("Nobody get approved.");
            return;
        }
        const workbook = new exceljs.Workbook();                            
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        const headers = [...weekDays, "Total"]; 
        const worksheet = workbook.addWorksheet(wk, {views: [{showGridLines: false}]});
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 18;
        const col1 = [];
        const col2 = [];
        const col3 = [];
        const col4 = [];
        const col5 = [];
        const col6 = [];
        for(let totalI = 0; totalI < mainData.length; totalI++){
            worksheet.getRow(1 + totalI * 9).style = {font:{bold: true}};
            for(let totalII = 0; totalII < 6; totalII++){
                const cell = worksheet.getCell(1 + totalI * 9, 1 + totalII);
                cell.fill = {
                    type: "pattern",
                    pattern:"solid",
                    fgColor:{argb:"00B0F0"}
                };
                cell.border = {
                    top: {style:"thick"},
                    left: {style:"thick"},
                    bottom: {style:"thick"},
                    right: {style:"thick"}
                };
            }
            for(let totalIII = 0; totalIII < 8; totalIII++){
                worksheet.getCell(2 + totalI * 9 + totalIII, 2).style = {font:{bold: true}};
                for(let totalIIII = 0; totalIIII < 5; totalIIII++){
                    const cell = worksheet.getCell(2 + totalI * 9 + totalIII, 2 + totalIIII);
                    if(totalIII % 2 === 1){
                        cell.fill = {
                            type: "pattern",
                            pattern:"solid",
                            fgColor:{argb:"D9E1F2"}
                        };
                        cell.border = {
                            top: {style:"thick"},
                            left: {style:"thick"},
                            bottom: {style:"thick"},
                            right: {style:"thick"}
                        };
                    }else{
                        cell.border = {
                            top: {style:"thick"},
                            left: {style:"thick"},
                            bottom: {style:"thick"},
                            right: {style:"thick"}
                        };
                    }
                }
            }

            const testData = mainData[totalI];
            col1.push(testData.name,"","","","","","","","");
            col2.push("Week Day",...headers);
            col3.push("Date", ...Array.from({length: 7}, (v, i) => (getDatefromWeekNum(wk, i))),"");
            col4.push("Regular", ...testData.form.map(c => 
                getReg(c.inOut.length && c.inOut.map(a => a.duration || 0).map(value => round(value, 2)).reduce(numberReducer, 0))
                || 0), testData.totalReg);
            col5.push("OT", ...testData.form.map(c => 
                getOT(c.inOut.length && c.inOut.map(a => a.duration || 0).map(value => round(value, 2)).reduce(numberReducer, 0))
                || 0), testData.totalOT);
            col6.push("Summary", ...testData.form.map(c => c.notes), "");
        }
        worksheet.getColumn(1).values = col1;
        worksheet.getColumn(2).values = col2;
        worksheet.getColumn(3).values = col3;
        worksheet.getColumn(4).values = col4;
        worksheet.getColumn(5).values = col5;
        worksheet.getColumn(6).values = col6;
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx}), 
            `time card export ${(new MyDate()).s()}.xlsx`);
        })
    }
    return (
        <span className = "pointer" onClick = {exportFunc}>
            Export
        </span>
    )
}